import React, { useEffect, useState } from "react";

import IADRLogo from "../../statics/logo/IADR-logo.svg";
import MainLogo from "../../statics/logo/logo.svg";
import { NavLink } from "react-router-dom";
import SEAADELogo from "../../statics/logo/SEAADE-logo.svg";
import useEvent from "../../hooks/useEvent";

const Logo = () => {
  const event = useEvent();
  const [currentLogo, setCurrentLogo] = useState<string>();
  const [width, setWidth] = useState("100%");

  useEffect(() => {
    if (event === "SEAADE") {
      setCurrentLogo(SEAADELogo);
      setWidth("150px");
    } else if (event === "IADR") {
      setCurrentLogo(IADRLogo);
      setWidth("150px");
    } else {
      setCurrentLogo(MainLogo);
      setWidth("300px");
    }
  }, [event]);

  return (
    <NavLink to="/">
      <img src={currentLogo} alt="Logo" width={width} />
    </NavLink>
  );
};

export default Logo;
